import React, { useMemo } from "react";
import styled from "styled-components";
import { Alert } from "components/bootstrap";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
const ESClusterStatus = styled(Alert)`
  margin-top: 10px;
  margin-bottom: 5px;
`;
const IndexerClusterHealthSummary = ({
  health,
  name = void 0
}) => {
  const formattedHealthStatus = health.status.toLowerCase();
  const alertClassForHealth = () => {
    switch (formattedHealthStatus) {
      case "green":
        return "success";
      case "yellow":
        return "warning";
      case "red":
        return "danger";
      default:
        return "success";
    }
  };
  const formattedTextForHealth = useMemo(() => {
    const text = `${(name == null ? void 0 : name.distribution) || "Elasticsearch"} cluster ${(name == null ? void 0 : name.name) || ""} is ${formattedHealthStatus}.`;
    switch (formattedHealthStatus) {
      case "green":
        return text;
      case "yellow":
      case "red":
        return /* @__PURE__ */ React.createElement("strong", null, text);
      default:
        return text;
    }
  }, [formattedHealthStatus, name]);
  return /* @__PURE__ */ React.createElement(ESClusterStatus, { bsStyle: alertClassForHealth() }, formattedTextForHealth, " Shards: ", health.shards.active, " active, ", health.shards.initializing, " initializing,", " ", health.shards.relocating, " relocating, ", health.shards.unassigned, " unassigned,", " ", /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.CLUSTER_STATUS_EXPLAINED, text: "What does this mean?" }));
};
export default IndexerClusterHealthSummary;
